import React, { Fragment } from "react";
import { twMerge } from "tailwind-merge";
import Dropdown from "../dropdown";
import { useWindowSize } from "../hooks/mediaQuery";

export interface BreadcrumbsProps extends React.HTMLAttributes<HTMLDivElement> {
  disableCollapse?: boolean;
}

function BreadcrumbsSeparator() {
  return <span className="text-slate-500 font-medium">/</span>;
}

export default function Breadcrumbs(props: Readonly<BreadcrumbsProps>) {
  const { children, className, disableCollapse = false, ...rest } = props;

  const size = useWindowSize();
  const childrenArray = React.Children.toArray(children);

  if (size === "xs" && childrenArray.length > 1 && !disableCollapse) {
    return (
      <Dropdown>
        <Dropdown.Toggle noStyle className="flex gap-1 items-center">
          {childrenArray.at(-1)}
        </Dropdown.Toggle>
        <Dropdown.Panel className="p-2">
          {childrenArray.toReversed().slice(1)}
        </Dropdown.Panel>
      </Dropdown>
    );
  }

  return (
    <div
      {...rest}
      className={twMerge("flex flex-wrap gap-2 items-center", className)}
    >
      {childrenArray[0]}
      {childrenArray.length > 1 && (
        <span className="text-slate-500 font-medium">/</span>
      )}
      {childrenArray.length > 4 && (
        <>
          <Dropdown menuPlacement="bottom">
            <Dropdown.Toggle noStyle toggleEnabled={false}>
              ...
            </Dropdown.Toggle>
            <Dropdown.Panel className="p-2">
              {childrenArray.slice(1, -3)}
            </Dropdown.Panel>
          </Dropdown>
          <BreadcrumbsSeparator />
        </>
      )}
      {childrenArray
        .slice(childrenArray.length > 4 ? childrenArray.length - 3 : 1)
        .map((child, i) => {
          if (i > 0) {
            const key = React.isValidElement(child) ? child.key : null;

            return (
              <Fragment key={key ?? i.toString()}>
                <BreadcrumbsSeparator />
                {child}
              </Fragment>
            );
          }

          return child;
        })}
    </div>
  );
}
